import React, { FC } from 'react';

import cls from 'classnames';
import { LinkItemProps } from './LinkItem.types';
import { CaretRightIcon, InfoIcon } from '@stashinvest/react-assets';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';

export const classNames = getClassNames('sds-link-item', [
	'variant-caret',
	'variant-avatar-caret',
	'variant-info-body',
	'variant-info-table',
	'variant-avatar',
	'left-icon',
	'avatar',
	'text',
	'left',
	'left-column',
	'right',
	'right-column',
	'top',
	'bottom',
	'slot1',
	'slot2',
	'right-icon',
	'is-disabled',
]);

const LinkItem: FC<LinkItemProps> = (props) => {
	const { variant, altText, onClick, href, isEnabled = true } = props;
	const fullClassName = cls(getRootClassListFromProps(classNames, props), {
		[classNames.isDisabled]: !isEnabled,
	});
	const avatarItem = variant.type === 'avatar' || variant.type === 'avatarCaret';
	let Icon;

	if (variant.type === 'caret') Icon = variant.Icon;
	const Inner = (
		<>
			<div className={classNames.leftColumn}>
				{((variant.type === 'caret' && variant.Icon) || avatarItem) && (
					<div className={classNames.leftIcon}>
						{variant.type === 'caret' && Icon && (
							<Icon size="XS" color={variant.iconColor} />
						)}

						{avatarItem && <div className={classNames.avatar}>{variant.avatar}</div>}
					</div>
				)}
				{(variant.type === 'caret' || variant.type === 'infoBody') && (
					<div className={classNames.text}>
						<p className={classNames.slot1}>{variant.title}</p>
						{variant.type === 'caret' && (
							<p className={classNames.slot2}>{variant.caption}</p>
						)}
					</div>
				)}

				{avatarItem && (
					<>
					<div className={classNames.left}>
						{(variant.bottomLeftText || variant.topLeftText) && (
							<>
								<p className="top">{variant.topLeftText}</p>
								{variant.bottomLeftText && (
									<p className="bottom">{variant.bottomLeftText}</p>
								)}
							</>
						)}
						</div>
					</>
				)}

				{variant.type === 'infoTable' && (
					<>
						<p className={classNames.slot1}>{variant.title}</p>
					</>
				)}
			</div>

			<div className={classNames.rightColumn}>
				{variant.type === 'infoTable' && (
					<>
						<p className={classNames.slot2}>{variant.detail}</p>
					</>
				)}
				{variant.type !== 'avatar' && (
					<div className={classNames.rightIcon}>
						{(variant.type === 'caret' || variant.type === 'avatarCaret') && (
							<CaretRightIcon size="XS" />
						)}
						{(variant.type === 'infoBody' || variant.type === 'infoTable') && (
							<InfoIcon size="XS" />
						)}
					</div>
				)}

				{variant.type === 'avatar' && (
					<>
						{(variant.bottomRightText || variant.topRightText) && (
							<div className={classNames.right}>
								<p className={classNames.top}>{variant.topRightText}</p>
								{variant.bottomRightText && (
									<p className={classNames.bottom}>{variant.bottomRightText}</p>
								)}
							</div>
						)}
					</>
				)}
			</div>
		</>
	);

	//TODO: Decide how we handle SPA links & make this into a generic 'clickable' HOC  / Wrapper
	return !href ? (
		<button
			className={fullClassName}
			onClick={onClick}
			title={altText}
			disabled={!isEnabled}
		>
			{Inner}
		</button>
	) : (
		<a className={fullClassName} href={href} onClick={onClick} title={altText}>
			{Inner}
		</a>
	);
};

LinkItem.displayName = 'LinkItem';

export default LinkItem;
